<app-topbar (showMobileNavigation)="showMobileNavigation=true"></app-topbar>
<app-sidebar [showMobileNavigation]="showMobileNavigation" (closeMobileNavigation)="showMobileNavigation=false"></app-sidebar>
<div class="router-wrapper">
  <router-outlet></router-outlet>
</div>